<template>
  <div>
    <div>
      <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading>
    </div>

    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>Client User Form</b-navbar-brand>
          <b-navbar-nav>
            <b-button @click="goBack" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
        </b-navbar>
        <b-card class="formCard">
          <b-card-text>
            <div>
              <md-layout md-gutter>
                <b-col md="3">
                  <label>
                    Company
                    <span class="error">*</span>
                  </label>
                  <multi-select
                    :options="$store.getters['common/getAllMultiClientList']"
                    :selected-options="company_items"
                    v-model="clientUserForm.fk_multi_client_id"
                    placeholder="Select Company"
                    :multiple="true"
                    id="Company"
                    @select="SelectMultiCompany"
                  ></multi-select>
                  <span class="error" v-if="!clientUserForm.fk_multi_client_id">
                    {{ errorList.fk_multi_client_id }}
                  </span>
                </b-col>

                <b-col md="3">
                  <label>
                    Client Name
                    <span class="error">*</span>
                  </label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="cu_name"
                    name="cu_name"
                    v-model="clientUserForm.cu_name"
                    placeholder="Please Enter Client Name"
                    type="text"
                  ></b-form-input>
                  <span class="error" v-if="!clientUserForm.cu_name">
                    {{ errorList.cu_name }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>
                    Contact
                    <span class="error">*</span>
                  </label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="contact"
                    name="contact"
                    v-model="clientUserForm.contact"
                    placeholder="Please Enter Contact"
                    type="text"
                  ></b-form-input>
                  <span class="error" v-if="!clientUserForm.contact">
                    {{ errorList.contact }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>
                    Email
                    <span class="error">*</span>
                  </label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="email"
                    name="email"
                    v-model="clientUserForm.email"
                    placeholder="Please Enter Email ID"
                    type="text"
                  ></b-form-input>
                  <span class="error" v-if="!clientUserForm.email">
                    {{ errorList.email }}
                  </span>
                </b-col>
                <b-col md="3">
                  <b-row>
                    <b-col sm="8">
                      <label>
                        Password
                        <span class="error">*</span>
                      </label>
                      <b-form-input
                        :disabled="clientUserForm.cu_id ? false : true"
                        :formatter="capitalizeAll"
                        id="password"
                        name="password"
                        v-model="clientUserForm.password"
                        placeholder="Please Enter Password"
                        type="text"
                        @input="PasswordChangeFlag()"
                      ></b-form-input>
                    </b-col>
                    <b-col sm="4" class="mt-5">
                      <b-button style="font-size: 0.675rem" @click="generatePassword"
                        >Generate</b-button
                      >
                    </b-col>
                    <span class="error" v-if="!clientUserForm.password">
                      {{ errorList.password }}
                    </span>
                  </b-row>
                </b-col>

                <b-col
                  md="3"
                  v-if="
                    $sessionsStorage.get('designation') == 'Admin' &&
                    $sessionsStorage.get('nameUser') == 'Bhavneesh'
                  "
                >
                  <label>
                    Prefrence
                    <span class="error"></span>
                  </label>
                  <model-list-select
                    class="ml-1"
                    :list="prefrenceList"
                    id="prefrence"
                    name="prefrence"
                    v-model="clientUserForm.prefrence"
                    option-value="preVal"
                    option-text="preText"
                    placeholder="Select Prefrence"
                  ></model-list-select>
                  <span class="error" v-if="!clientUserForm.prefrence">
                    {{ errorList.prefrence }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>
                    Address
                    <span class="error"></span>
                  </label>
                  <b-textarea
                    :formatter="capitalizeAll"
                    id="address"
                    name="address"
                    type="text"
                    v-model="clientUserForm.address"
                    placeholder="Please Enter Address"
                  ></b-textarea>
                  <span class="error" v-if="!clientUserForm.address">
                    {{ errorList.address }}
                  </span>
                </b-col>
              </md-layout>
            </div>
            <hr />
            <div>
              <b-col md="3"></b-col>
              <b-col md="3">
                <b-button
                  size="sm"
                  class="pull-right"
                  style="margin:left:5px"
                  variant="primary"
                  @click="addClientUserForm"
                  >Save</b-button
                >

                <b-button
                  v-if="clientUserForm.cu_id"
                  variant="outline-primary"
                  style="font-size: 0.675rem"
                  @click="approveUser(row2.item)"
                  id="addButtonLoader"
                  size="sm"
                  >Approve</b-button
                >
              </b-col>
              <b-col md="3"></b-col>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import {
  globalPermissionStatus,
  GlobalGetLocation,
  GlobalGetCommodity,
} from "../../helper/collection";
import ClientUserService from "../../services/ClientUserService.js";

export default {
  beforeMount() {
    this.$store.dispatch(
      "common/setAllMultiClientList",
      JSON.stringify({
        itemCode: "MultiClientList",
      })
    );
    if (
      this.$sessionsStorage.get("edit_cu_id") != undefined &&
      this.$sessionsStorage.get("edit_cu_id") != null &&
      this.$sessionsStorage.get("edit_cu_id") != ""
    ) {
      this.getSingleClientUser(this.$sessionsStorage.get("edit_cu_id"));
    } else {
      this.generatePassword();
    }
    if (globalPermissionStatus("Client User") != "Disabled") {
      this.$sessionsStorage.set(
        "PermissionStatus",
        globalPermissionStatus("Client User")
      );
      this.$store.dispatch("setCurrentRoute", "/client/user/upsertClientUser");
      this.windowSize = $(window).width();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  watch: {},
  data() {
    return {
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      orgPass: "",
      company_items: [],
      prefrenceList: [
        {
          preVal: 1,
          preText: "Normal",
        },
        {
          preVal: 2,
          preText: "GPS",
        },
      ],
      clientUserForm: {
        cu_id: "",
        cu_name: "",
        fk_multi_client_id: "",
        multi_client_name: "",
        companyDetails: "",
        contact: "",
        email: "",
        address: "",
        password: "",
        passwordFlag: false,
        prefrence: 1, //1:Normal,2:GPS
      },
      clientUserFormError: [
        "Please Select Company",
        "Please Enter Client Name",
        "Please Enter Email",
        "Please Enter Mobile",
      ],
      errorList: {
        fk_multi_client_id: "",
        cu_name: "",
        email: "",
        contact: "",
      },
      selectDateFormat,
      companyDetails: [],

      isLoading: false,
      validate: false,

      docURL: URL_BASE_DOC,
    };
  },

  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    Loading,
    MultiSelect,
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  computed: {
    disbleClientUser() {
      return this.clientUserForm.cu_id != "" ? true : false;
    },
  },
  methods: {
    generatePassword() {
      const length = 12;
      const characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()";
      let result = "";
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
      }
      this.clientUserForm.password = result;
    },
    goBack() {
      window.history.go(-1);
    },
    setClientUserDetails(item, cu_id) {
      if (cu_id != undefined && cu_id != null && cu_id != "") {
        let clientUser_details = item;
        console.log("clientUser_details", clientUser_details);

        let multi_client_name = [];
        let fk_multi_client_id = [];
        if (
          clientUser_details.multi_client_name != undefined &&
          clientUser_details.multi_client_name != null &&
          clientUser_details.multi_client_name != ""
        ) {
          multi_client_name = clientUser_details.multi_client_name.split(",");
          fk_multi_client_id = clientUser_details.fk_multi_client_id.split(",");
        }
        this.clientUserForm = {
          cu_id: clientUser_details.cu_id,
          cu_name: clientUser_details.cu_name,
          fk_multi_client_id: clientUser_details.fk_multi_client_id,
          multi_client_name: clientUser_details.multi_client_name,
          companyDetails: JSON.parse(clientUser_details.companyDetails),
          contact: clientUser_details.contact,
          email: clientUser_details.email,
          address: clientUser_details.address,
          password: clientUser_details.password,
          passwordFlag: false,
          prefrence: clientUser_details.prefrence, //1:Normal,2:GPS
        };
        this.orgPass = clientUser_details.password;
        this.company_items = this.clientUserForm.companyDetails;
        this.companyDetails = this.clientUserForm.companyDetails;
        console.log("companyDetails=>", this.clientUserForm.companyDetails);
      } else {
        this.clientUserForm = {
          cu_name: "",
          fk_multi_client_id: "",
          multi_client_name: "",
          companyDetails: "",
          contact: "",
          email: "",
          address: "",
          password: "",
          passwordFlag: false,
          prefrence: 1, //1:Normal,2:GPS
        };
      }
    },

    SelectMultiCompany(company_items, lastSelectItem) {
      this.company_items = company_items;
      this.companyDetails = company_items;
      console.log("companyDetails=>", this.companyDetails);

      this.clientUserForm.fk_multi_client_id = "";
      this.clientUserForm.multi_client_name = "";
      if (this.companyDetails) {
        this.company_items.forEach((item_val) => {
          if (this.clientUserForm.multi_client_name) {
            this.clientUserForm.multi_client_name =
              this.clientUserForm.multi_client_name + "," + item_val.text;
          } else {
            this.clientUserForm.multi_client_name = item_val.text;
          }

          if (this.clientUserForm.fk_multi_client_id) {
            this.clientUserForm.fk_multi_client_id =
              this.clientUserForm.fk_multi_client_id + "," + item_val.value;
          } else {
            this.clientUserForm.fk_multi_client_id = item_val.value;
          }
        });
        console.log("companyDetails=>", this.clientUserForm);
      }
    },
    validateLeads() {
      let validate_new = true;
      Object.keys(this.errorList).map((x, index) => {
        if (
          this.clientUserForm[x] == "" ||
          this.clientUserForm[x] == undefined ||
          this.clientUserForm[x] == null
        ) {
          this.errorList[x] = this.clientUserFormError[index];
          validate_new = false;
        }
      });
      if (validate_new != true) {
        this.validate = false;
        return;
      } else {
        this.validate = true;
      }
    },
    PasswordChangeFlag() {
      this.clientUserForm.passwordFlag = false;
      if (this.orgPass) {
        if (this.orgPass != this.clientUserForm.password) {
          this.clientUserForm.passwordFlag = true;
        }
      }
    },
    addClientUserForm() {
      this.validateLeads();

      console.log("clientUserForm=>", this.clientUserForm);
      console.log("errorList=>", this.errorList);

      // this.clientUserForm.AddressArr = JSON.stringify(this.AddressArr);
      this.clientUserForm.TypeofAdd = "Client User Master Add";
      if (this.validate == false) return false;
      this.clientUserForm.companyDetails = JSON.stringify(this.companyDetails);
      this.isLoading = true;
      let payload = {
        itemCode: "add_Client_User_Details",
        clientUserForm: this.clientUserForm,
      };
      // console.log("payload=>", payload);
      // return false;
      payload = JSON.stringify(payload);
      if (this.validate != false) {
        ClientUserService.getAllClientUserList(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (data.cu_id != "" && data.cu_id != undefined) {
              if (data.find == 1 || data.find == 2) {
                this.alert.content = data.MSG;
              } else {
                this.alert.content = data.MSG;
              }
              if (data.flag == true) {
                this.$router.push({
                  path: "/client/user",
                });
              }
            } else {
              this.alert.content = data.MSG;
            }
            this.isLoading = false;
            this.$refs["addPop"].open();
          })
          .catch((error) => {
            console.log("Catch on Proforma Error: ", error);
          });
      }
    },
    approveUser(item) {
      if (item.cu_id) {
        this.isLoading = true;
        let payload = {
          itemCode: "Send_Approval_Mail",
          clientUserForm: item,
        };
        payload = JSON.stringify(payload);
        if (this.validate != false) {
          ClientUserService.getAllClientUserList(payload)
            .then((response) => {
              const { data, status, statusText } = response;
              if (data.cu_id != "" && data.cu_id != undefined) {
                if (data.find == 1 || data.find == 2) {
                  this.alert.content = data.MSG;
                } else {
                  this.alert.content = data.MSG;
                }
                if (data.flag == true) {
                  this.$router.push({
                    path: "/client/user",
                  });
                }
              } else {
                this.alert.content = data.MSG;
              }
              this.isLoading = false;
              this.$refs["addPop"].open();
            })
            .catch((error) => {
              console.log("Catch on Proforma Error: ", error);
            });
        }
      }
    },

    getSingleClientUser(id) {
      this.isLoading = true;
      let payload = {
        itemCode: "Single_Client_Users",
        cu_id: id,
      };
      ClientUserService.getAllClientUserList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            // this.clientUserForm = data.singleClient_User;
            this.setClientUserDetails(
              data.singleClient_User,
              data.singleClient_User.cu_id
            );
            console.log(" Single ClientUser response=>", data);
          }

          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on Single ClientUser Error: ", error);
        });
    },

    previousFFView() {
      window.history.go(-1);
    },
    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type,
      };
      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
  },
};
</script>
<style scoped>
.quotePMargin {
  margin: 0px;
  text-align: left !important;
}
.md-direction-bottom-right {
  width: 18% !important;
}

.md-flex-xsmall-100 {
  min-width: 100%;

  flex: 0 1 100%;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// upsertClientUser.vue?71fcc312